import { createBrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AnonymousOnly, RequireAuthenticated, RequirePendingOnboarding } from './routeGuards';
import { AppShell } from '../components/layout/AppShell';
import RootRedirect from '../features/RootRedirect';
import LoginPage from '../features/login/LoginPage';
import AuthCompletePage from '../features/auth/AuthCompletePage';
import LogoutPage from '../features/auth/LogoutPage';
import OnboardingPage from '../features/onboarding/OnboardingPage';
import AccountPage from '../features/account/AccountPage';
import ProfilePage from '../features/account/ProfilePage';
import ConnectionsPage from '../features/account/ConnectionsPage';
import SecurityPage from '../features/account/SecurityPage';
import ErrorPage from '../features/errors/ErrorPage';
import NotFoundPage from '../features/errors/NotFoundPage';

export const routes = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <RootRedirect /> },
      { path: 'auth/complete', element: <AuthCompletePage /> },
      { path: 'error', element: <ErrorPage /> },
      {
        element: <AnonymousOnly />,
        children: [{ path: 'login', element: <LoginPage /> }],
      },
      {
        element: <RequirePendingOnboarding />,
        children: [{ path: 'onboarding', element: <OnboardingPage /> }],
      },
      {
        element: <RequireAuthenticated />,
        children: [
          {
            element: <AppShell />,
            children: [
              { path: 'account', element: <AccountPage /> },
              { path: 'account/profile', element: <ProfilePage /> },
              { path: 'account/connections', element: <ConnectionsPage /> },
              { path: 'account/security', element: <SecurityPage /> },
            ],
          },
          { path: 'logout', element: <LogoutPage /> },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
